import { useEffect, useState } from "react"
import { Table } from "antd"
import Column from "antd/lib/table/Column"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface Prop {
    dealID?: string
}

export default function (prop: Prop) {

    const [data, setData] = useState<any[]>([])

    useEffect(() => {
        if (prop.dealID) {
            baseAxiosNoInfo('/yuesao_center/customer/detail/nursing_work_records', {
                params: {
                    deal_id: prop.dealID,
                }
            }).then((res: any) => {
                res && setData(res)
            })
        }
    }, [prop.dealID])

    return <div className="follow-record">
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 服务记录 */}
        <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={data}>
            <Column title="护理师" dataIndex="belong_nursing_name" />
            <Column title="护理模式" dataIndex="nursing_care_type_desc" />
            <Column title="服务开始日期" dataIndex="service_start_date" />
            <Column title="服务结束日期" dataIndex="service_end_date" />
            <Column title="服务天数" dataIndex="service_days" />
            <Column title="服务状态" dataIndex="service_status_desc" />
            <Column title="提前下单原因" dataIndex="advance_reason" />
            <Column title="提前下单操作人" dataIndex="advance_handle_operator_user_name" />
            <Column title="创建人" dataIndex="create_user_name" />
            <Column title="创建时间" dataIndex="create_time" />
        </Table>
    </div>
}